import { FC, useEffect } from "react";
import { useI18n } from "../../../hooks/useTranslations";
import { CostTypeCategory } from "../../../http/costTypeCategories/types";
import Form from "../../ui/Form";
import FormField from "../../ui/FormField";
import FormFieldsContainer from "../../ui/FormFieldsContainer";
import Input from "../../ui/Input";

export interface CostTypeCategoryFormBody {
  name: string;
}

type CostTypeCategoryFormProps = {
  costTypeCategory?: CostTypeCategory | null;
  onSubmit: (form: CostTypeCategoryFormBody) => Promise<void>;
  isDisabled?: boolean;
  isLoading?: boolean;
};

const CostTypeCategoryForm: FC<CostTypeCategoryFormProps> = ({
  costTypeCategory,
  onSubmit,
  isDisabled,
  isLoading,
}: CostTypeCategoryFormProps) => {
  const i18n = useI18n();

  const defaultValues = {
    name: costTypeCategory?.name,
  };

  return (
    <Form<CostTypeCategoryFormBody>
      defaultValues={defaultValues}
      submitText={i18n.t.common.save}
      disabled={isDisabled || isLoading}
      onSubmit={() => onSubmit}
      itemCreationInfo={costTypeCategory}
    >
      {({ register, reset, formState: { errors } }) => {
        useEffect(() => {
          reset(defaultValues);
        }, [costTypeCategory]);

        return (
          <FormFieldsContainer>
            <FormField label={i18n.t.common.name} error={errors.name}>
              {({ labelId, isInvalid }) => (
                <Input
                  id={labelId}
                  isInvalid={isInvalid}
                  disabled={isDisabled || isLoading}
                  {...register("name", {
                    required: true,
                    minLength: 1,
                  })}
                />
              )}
            </FormField>
          </FormFieldsContainer>
        );
      }}
    </Form>
  );
};

export default CostTypeCategoryForm;
